import getOr from 'lodash/fp/getOr';

// eslint-disable-next-line import/prefer-default-export
export const getWaitingList = getOr({}, 'settings.waitingList');
